export const LOG_COLUMNS = [
  { key: "name", label: "Lead Name" },
  { key: "company", label: "Company" },
  { key: "email", label: "Email" },
  { key: "phone", label: "Phone #" },
  { key: "source", label: "Source" },
  { key: "status", label: "Status" },
  { key: "setter", label: "Setter", get: (r) => r._setterName },
  { key: "closer", label: "Closer", get: (r) => r._closerName },
  { key: "date_created", label: "Date Created", type: "datetime" },
  { key: "first_contact_at", label: "First Contact", type: "datetime" },
  { key: "date_booked", label: "Date Booked", type: "date" },
  { key: "meeting_date", label: "Date of Meeting", type: "date" },
  { key: "meeting_status", label: "Meeting Status" },
  { key: "offer_made", label: "Offer Made", type: "bool" },
  { key: "sale_type", label: "Sale Type" },
  { key: "loss_reason", label: "Loss Reason" },
  { key: "deposit_amount", label: "Deposit Amount", type: "money" },
  { key: "deposit_date", label: "Deposit Date", type: "date" },
  { key: "total_deal_value", label: "Total Deal Value", type: "money" },
  { key: "cash_collected", label: "Cash Collected", type: "money" },
  { key: "date_paid_in_full", label: "Date Paid In Full", type: "date" },
  { key: "refund_amount", label: "Refund/Clawback", type: "money" },
  { key: "setter_pct", label: "Setter %", type: "pct" },
  { key: "closer_pct", label: "Closer %", type: "pct" },
  { key: "setter_earnings", label: "Setter Earnings", type: "money", get: (r) => r._setterEarn },
  { key: "closer_earnings", label: "Closer Earnings", type: "money", get: (r) => r._closerEarn },
  { key: "last_touch_date", label: "Last Touch", type: "date" },
  { key: "flags", label: "Leak Flags", type: "flags", get: (r) => r._flags.length },
];

const DESC_FIRST = ["money", "pct", "flags", "date", "datetime"];
export const firstDir = (col) => (DESC_FIRST.includes(col.type) ? "desc" : "asc");
export const getVal = (col, row) => (col.get ? col.get(row) : row[col.key]);

const isEmpty = (v) => v === null || v === undefined || v === "";

export const compareRows = (col, dir) => (a, b) => {
  const va = getVal(col, a);
  const vb = getVal(col, b);
  if (isEmpty(va) && isEmpty(vb)) return 0;
  if (isEmpty(va)) return 1;
  if (isEmpty(vb)) return -1;
  const res = typeof va === "number" || typeof va === "boolean"
    ? Number(va) - Number(vb)
    : String(va).localeCompare(String(vb), "en", { sensitivity: "base" });
  return dir === "asc" ? res : -res;
};
